import { FlagType } from '~/flags/flags';
import { getFlag } from '~/flags/useFlag';
import { EntityQuery } from '~/types/OpenSearch';

export const withQueryFormat = (query: EntityQuery[]): EntityQuery[] =>
  getFlag(FlagType.DeprecatePilotSearchInSylvanus)
    ? query.map((item) =>
        item.type === 'filter'
          ? { ...item, query_format: 'evisearch' as const }
          : item,
      )
    : query;
